import React, { useRef, useEffect } from 'react';
import { FaChevronDown } from "react-icons/fa6";
import { RxCross1 } from "react-icons/rx";
import Button from 'react-bootstrap/Button';
import './CustomAccordion.scss';

const CustomAccordion = ({
  title,
  children,
  previewData,
  showToggleButtons = false,
  filterType = 'include',
  onFilterTypeChange,
  onRemove,
  isOpen = false,
  onToggle,
  category = '',
  closeFromBottom = false
}) => {
  const contentRef = useRef(null);
  const [height, setHeight] = React.useState(0);

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        // Set to scrollHeight when opening
        setHeight(contentRef.current.scrollHeight);
      } else {
        // Set to 0 when closing
        setHeight(0);
      }
    }
  }, [isOpen, children]);
  // Check if there's any preview data to display
  const hasPreviewData = previewData && Object.entries(previewData).some(
    ([key, value]) => {
      return (typeof value === "string" && value !== "") ||
             (typeof value === "boolean" && value === true);
    }
  );

  // Format key for display (camelCase to readable format)
  const formatKey = (key) => {
    return key.replace(/([a-z]+|[A-Z][a-z]+|\d+)/g, "$1 ").toLowerCase();
  };

  return (
    <div className={`custom-accordion-item ${category} ${isOpen ? 'open' : 'closed'}`}>
      <div className="custom-accordion-header-wrapper">
        {/* Row 1: Title + Chevron + Cross (always on same line) */}
        <div className="custom-accordion-header" onClick={onToggle}>
          <div className="title-section">
            <h5 className="accordion-title">{title}</h5>
            <div className="title-controls">
              <div className={`custom-accordion-chevron ${isOpen ? 'open' : ''}`}>
                <FaChevronDown />
              </div>
              <button
                className="remove-catalog-entry-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove();
                }}
              >
                <RxCross1 />
              </button>
            </div>
          </div>
          {/* Row 2 on mobile: Toggle buttons (if present) */}
          {showToggleButtons && (
            <div className="controls-section">
              <div className="form-toggle-buttons">
                <Button
                  className={filterType === 'include' ? 'btn-success' : 'btn-outline-secondary'}
                  onClick={(e) => {
                    e.stopPropagation();
                    onFilterTypeChange('include');
                  }}
                  size="sm"
                >
                  Include
                </Button>
                <Button
                  className={filterType === 'exclude' ? 'btn-danger' : 'btn-outline-secondary'}
                  onClick={(e) => {
                    e.stopPropagation();
                    onFilterTypeChange('exclude');
                  }}
                  size="sm"
                >
                  Exclude
                </Button>
              </div>
            </div>
          )}
        </div>

        {/* Row 2: Preview (only shown if has data) */}
        {hasPreviewData && (
          <div className="catalog-entry-preview">
            {Object.entries(previewData).map(([key, value], index) => {
              const shouldDisplay = (typeof value === "string" && value !== "") ||
                                   (typeof value === "boolean" && value === true);

              if (!shouldDisplay) return null;

              return (
                <span key={index}>
                  <span className="catalog-entry-preview-key">
                    {formatKey(key)}:
                  </span>
                  <span>{String(value).toLowerCase()}</span>
                </span>
              );
            })}
          </div>
        )}
      </div>

      {/* Accordion Body */}
      <div
        className={`custom-accordion-body ${isOpen ? 'open' : 'closed'} ${closeFromBottom ? 'close-from-bottom' : 'close-from-top'}`}
        style={{ height: `${height}px` }}
      >
        <div ref={contentRef} className="custom-accordion-body-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomAccordion;
